import React, { useState } from 'react';
import { BarChart3 } from 'lucide-react';
import { InputGroup, InfoBox, fmtCur, formatCurrencyExt } from '../Common';

const EVTool = () => {
    const [wr, setWr] = useState(45);
    const [aw, setAw] = useState(15);
    const [al, setAl] = useState(10);
    const [ls, setLs] = useState(65);
    const [l, setL] = useState(4);

    const wr_dec = wr / 100;
    const ev = (wr_dec * aw) - ((1 - wr_dec) * al);
    const v = ls * l;
    const ep = ev * v;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title"> Expected Value Calculator</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Win Rate %" value={wr} onChange={setWr} />
                <InputGroup label="Avg Win Pts" value={aw} onChange={setAw} />
                <InputGroup label="Avg Loss Pts" value={al} onChange={setAl} />
                <InputGroup label="Lot Size" value={ls} onChange={setLs} />
                <InputGroup label="Lots" value={l} onChange={setL} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-blue">
                    <div className="tct-data-row">
                        <span className="tct-label">Expected Value (EV)</span>
                        <span className={`tct-value big-value ${ev > 0 ? 'val-green' : 'val-red'}`}>{ev.toFixed(2)} pts</span>
                    </div>
                    <div className="tct-data-row">
                        <span className="tct-label">EV Profit Per Trade (₹{v}/pt)</span>
                        <span className={`tct-value ${ep > 0 ? 'val-green' : 'val-red'}`}>{formatCurrencyExt(ep)}</span>
                    </div>
                </div>
            </div>
            <InfoBox
                title="Expected Value in Trading"
                meta="How to Know if Your Strategy Has an Edge"
                sections={[
                    { title: "Introduction", content: "Most traders focus on win rate, but professionals focus on expected value. Expected value tells you whether a trading strategy will make money over many trades.<br><br>It answers a simple question:<br>If I repeat this trade hundreds of times, will I make money?" },
                    { title: "Formula", type: "formula", content: "Expected Value = (Win Rate × Average Win) − (Loss Rate × Average Loss)" },
                    { title: "Example", content: "Win rate = 45%<br>Average win = 15 points<br>Average loss = 10 points<br><br>EV = (0.45 × 15) − (0.55 × 10)<br>EV = 1.25 points<br><br>This means every trade is worth 1.25 points on average." },
                    { title: "Why Expected Value Matters", content: "Even if you lose many trades, a positive EV strategy will grow capital over time.<br><br>This is how:<br>• hedge funds<br>• prop trading firms<br>• algorithmic traders<br>evaluate strategies." },
                ]}
            />
        </div>
    );
};

export default EVTool;
